import React from 'react';

import utils from './MoleculeCardUtils';
import MoleculeCardTag from './MoleculeCardTag';


export default class MoleculeCardTagBar extends React.Component {

  render() {
    const { molecule } = this.props;
    const tags = utils.parseMolecule(
      molecule || {}, 'tag', 'tag', 'render'
    );
    return (
      <div>
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          textAlign: 'left',
        }}>
          {tags.map((tag, index) => {
            return (
              <li
                key={tag.fp}
                style={{
                  display: 'inline-block',
                  margin: '2px',
                }}
              >
                <MoleculeCardTag content={tag.content} />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCardTagBar.jsx